<div class="p-2">
  <div class="sub-bg">
    <div class="container-fluid policy-header">
      <div class="row d-flex align-items-center">
        <div class="col-md-3 px-0">
          <app-search #searchPlaceholder [placeholder]="'Search'|translate" (keyup)="searchTable($event)"></app-search>
        </div>
        <div class="col-md-9">
          <div class="d-flex justify-content-end align-items-center">

            <button class="btn submit" *ngIf="checkPermission('save')"
              [routerLink]="['/app/master/policy-master/add-policy-master']" routerLinkActive="router-link-active">
              {{'Add'|translate}}
              <!-- {{ pageTitle }} -->
            </button>
            <app-action-button (viewChange)="onViewChange($event)" [activeView]="viewType">
            </app-action-button>
            <app-table-export-import-button [tableId]="'menusTable'" tablename="policy_master"
              [listData]="listData" [reportName]="'policyMasterTable'" [sectionid]="29" [hiddenOptions]="['download', 'upload']"
              [fetchAllData]="getAllPolicyAllowanceBenefitsForExport.bind(this)" [exportColumns]="myColumns"
              *ngIf="checkPermission('export')">
            </app-table-export-import-button>
           

          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Table -->
  <!-- <div class="p-2 my-2" *ngIf="listView">
      <p-table id="menusTable" styleClass="p-datatable-gridlines" class="master-table" [value]="listData"
        [rows]="pageSize" [responsive]="true" [showCurrentPageReport]="true" [totalRecords]="totalRecords" [lazy]="true"
        (onLazyLoad)="onLazyLoad($event)">
        <ng-template pTemplate="header">
          <tr class="head">
            <th class="tHead text-center">S.No</th>
            <th *ngIf="!hideCompany" class="tHead table-width-title">Company</th>
            <th class="tHead table-width-title w-25">
              Title
            </th>
            <th class="tHead">
              Description
            </th>
            <th class="tHead" style="width: 20%">Created On</th>
            <th class="tHead" style="width: 20%">Modified On</th>
            <th class="tHead" style="width: 20%">Created By</th>
            <th class="tHead" style="width: 20%">Modified By</th>
            <th class="tHead" style="width: 20%">Status</th>
            <th class="text-center tHead" *ngIf="checkPermission('edit')||checkPermission('delete')">Action
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-master let-i="rowIndex">
          <tr *ngIf="listData.length !== 0">
            <td class="table-td text-center">{{ i + 1 }}</td>
            <td *ngIf="!hideCompany" class="table-width-title">
              {{ master?.CompanyModel?.company_name }}
            </td>
            <td class="table-td table-width-title">{{ master.title }}</td>
            <td class="table-td table-width-descrip single-line">
              {{ getShortText(master.description, 5) }}
            </td>

            <td class="table-width-allowance">
              {{ master?.createdAt | customDate: (angularDateFormat || dateFormat) + ' hh:mm a' }}
            </td>
            <td class="table-width-allowance">
              {{ master?.updatedAt && master?.updatedAt !== master?.createdAt
              ? (master?.updatedAt | customDate: (angularDateFormat || dateFormat) + ' hh:mm a')
              : '---' }}
            </td>
            <td class="table-width-allowance">
              {{ master?.createdBy?.name ? master.createdBy.name + (master.createdBy.role == 2 ? ' (Admin)' :
              ' (Hr)') :
              '---' }}
            </td>
            <td class="table-width-allowance">
              {{ master?.updatedBy?.name ? master.updatedBy.name + (master.updatedBy.role == 2 ? ' (Admin)' :
              ' (Hr)') :
              '---' }}
            </td>
            <td class="text-center" [ngClass]="{ 'active': master.status == 1, 'inactive': master.status != 1 }">
              {{ master.status ? 'Active' : 'Inactive' }}
            </td>
            <td style="text-align: center" *ngIf="checkPermission('edit')||checkPermission('delete')">
              <i class="fa-regular fa-pen-to-square" (click)="openGallery(mediacontent, 'Edit', master)"
                routerLinkActive="router-link-active" *ngIf="checkPermission('edit')"></i>
            </td>
          </tr>
        </ng-template>
        <div *ngIf="listData.length == 0" class="p-3 text-center">
          No records to show
        </div>
      </p-table>
    </div>
    <div *ngIf="listData.length === 0 && listView" class="p-3 text-center">
      No records to show
    </div>
    <ngb-pagination *ngIf="listView && listData.length != 0" class="pagination-master" [maxSize]="10"
      [collectionSize]="totalRecords" [page]="page" [pageSize]="pageSize" [rotate]="true" [ellipses]="false"
      [boundaryLinks]="true" (pageChange)="handlePageChange($event)">
    </ngb-pagination> -->


  <div [hidden]="viewType !== 'list'">
    <app-custom-table #customTable [listData]="listData" [selectedColumns]="myColumns" [tableName]="'policyMasterTable'"
      [moduleKey]="'policyMasterModule'" [totalRecords]="totalRecords" [maxSize]="pageSize" [menuId]="menuId"
      [collectionSize]="totalRecords" [page]="page" [pageSize]="pageSize" [sectionid]="29"
      (pageChanges)="handleFilterChange($event)" [angularDateFormat]="angularDateFormat"
      [dateFormat]="dateFormat" (columnsChanged)="myColumns = $event"></app-custom-table>
    <ngb-pagination *ngIf="listData && listData.length != 0" class="pagination-master" [maxSize]="pageSize"
      [collectionSize]="totalRecords" [(page)]="page" [pageSize]="pageSize" [rotate]="true" [ellipses]="false"
      [boundaryLinks]="true" (pageChange)="handlePageChange($event)">
    </ngb-pagination>
  </div>
  <!-- GRID VIEW -->
  <div [hidden]="viewType !== 'grid'">
    <app-custom-grid [listData]="listData" [totalRecords]="totalRecords" [canEdit]="checkPermission('edit')" [moduleKey]="'policyMasterModule'"
      [angularDateFormat]="angularDateFormat" [dateFormat]="dateFormat">
    </app-custom-grid>
    <ngb-pagination *ngIf="listData && listData.length != 0" class="pagination-master" [maxSize]="pageSize"
      [collectionSize]="totalRecords" [(page)]="page" [pageSize]="pageSize" [rotate]="true" [ellipses]="false"
      [boundaryLinks]="true" (pageChange)="handlePageChange($event)">
    </ngb-pagination>
  </div>
</div>

<!-- Popup -->
<ng-template #mediacontent let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">
      {{ popupType == "Add" ? "Create New" : popupType }} {{ pageTitle }}
    </h5>
    <i class="fas fa-times close-icon" (click)="clearForm()"></i>
  </div>

  <div class="modal-body master">
    <div class="form-group row">
      <form [formGroup]="form">
        <div class="row">
          <!-- Company -->
          <div class="col-md-12" *ngIf="!hideCompany">
            <label class="form-label required" for="company_id">Company</label>
            <select class="form-select" formControlName="company_id" (change)="onCompanyChange($event)" #nameInput
              [disabled]="popupType == 'View'" [ngClass]="{ 'is-invalid': isInvalid('company_id') }">
              <option *ngFor="let company of companyList" [value]="company.id">
                {{ company.company_name }}
              </option>
            </select>
            <div *ngIf="isInvalid('company_id')" class="invalid-feedback">
              <span *ngIf="form.get('company_id')?.errors?.['required']">
                Company is required.
              </span>
            </div>
          </div>

          <!-- Title -->
          <div class="col-md-6 mt-3">
            <label class="form-label required" for="title">Title</label>
            <input type="text" id="title" class="form-control" placeholder="Title" formControlName="title" #titleInput
              [readonly]="popupType == 'View' ? true : false" [ngClass]="{ 'is-invalid': isInvalid('title') }" />
            <div *ngIf="isInvalid('title')" class="invalid-feedback">
              <span *ngIf="form.get('title')?.errors?.['required']">
                Title is required.
              </span>
              <span *ngIf="form.get('title')?.errors?.['pattern']">
                Enter valid title.
              </span>
            </div>
          </div>

          <div class="mt-3 col-md-6">
            <label class="form-label required" for="code">Code</label>
            <input type="text" id="code" maxlength="15" class="form-control" placeholder="Code" formControlName="code"
              [readonly]="popupType == 'Add' ? false : true" [ngClass]="{ 'is-invalid': isInvalid('code') }" />
            <div *ngIf="isInvalid('code')" class="invalid-feedback">
              <span *ngIf="form.get('code')?.errors?.['required']">
                Code is required.
              </span>
            </div>
          </div>

          <div class="col-md-3 d-flex flex-column justify-content-start">
            <div class="mt-3">
              <label class="form-label" for="acknowledgement">Acknowledgement</label>
              <div class="form-check form-switch">
                <input class="form-check-input pointer" formControlName="acknowledgement" type="checkbox"
                  role="switch" />
              </div>
            </div>
          </div>

          <div class="col-md-3 d-flex flex-column justify-content-start">
            <div class="mt-3">
              <label class="form-label" for="status">Status</label>
              <div class="form-check form-switch">
                <input class="form-check-input pointer" formControlName="status" type="checkbox" role="switch" />
              </div>
            </div>
          </div>

          <div class="mt-3 col-md-6">
            <label class="form-label" for="skip_count">Skip Count</label>
            <input class="form-control form-control" formControlName="skip_count" type="number"
              placeholder="{{'Skip Count'|translate}}" min="0" max="50"
              [ngClass]="{ 'is-invalid': isInvalid('skip_count') }" />
            <div *ngIf="isInvalid('skip_count')" class="invalid-feedback">
              <span *ngIf="form.get('skip_count')?.errors?.['min']">
                {{"Value cannot be less than 0."|translate}}
              </span>
              <span *ngIf="form.get('skip_count')?.errors?.['max']">
                {{"Value cannot be greater than 50."|translate}}
              </span>
              <span *ngIf="form.get('skip_count')?.errors?.['pattern']">
                {{"Enter valid number."|translate}}
              </span>
            </div>
          </div>

          <div class="mt-3 col-md-6">
            <label class="form-label" for="image">Image</label>
            <input type="file" id="image" accept=".jpg, .jpeg, .png" class="form-control" *ngIf="!imagePreview"
              (change)="onImageChange($event)" [disabled]="popupType == 'View'" />
            <div *ngIf="imagePreview" class="image-preview-container mt-2" style="min-height: 10px">
              <div class="image-preview">
                <img [src]="imagePreview" alt="Selected" class="img-thumbnail" />
                <button class="close-btn" (click)="removeImage()">×</button>
              </div>
            </div>
          </div>

          <div class="mt-3 col-md-6  d-flex flex-column justify-content-end">
            <button class="btn btn-md btn-outline-primary" (click)="open(textExtractModal)">
              <i class="fa fa-upload"></i>
              Text Extract
            </button>
          </div>

          <div class="col-sm-12 mt-3">
            <!-- <div class="editor">
              <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
              <ngx-editor [editor]="editor" [(ngModel)]="htmlContent"
                [ngClass]="{ 'is-invalid': isInvalid('description') }" formControlName="description"></ngx-editor>
              <div *ngIf="isInvalid('description')" class="invalid-feedback">
                <span *ngIf="form.get('description')?.errors?.['required']">
                  Content is required.
                </span>
                <span *ngIf="form.get('description')?.errors?.['maxlength']">
                  Maximum 255 characters.
                </span>
                <span *ngIf="form.get('description')?.errors?.['pattern']">
                  Enter Valid Description.
                </span>
              </div>
            </div> -->
          </div>


          <div class="mt-3 text-end">
            <button type="button" class="btn cancel mx-3" (click)="clearForm()">
              Cancel
            </button>
            <button [disabled]="!isDisable || form.invalid" *ngIf="
              popupType != 'View' &&
              checkPermission(popupType == 'Add' ? 'save' : 'edit')
            " type="button" class="btn submit" (click)="formSubmit()">
              {{ popupType == "Add" ? "Create" : "Update" }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #textExtractModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Extract Text from File</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <input type="file" class="form-control" (change)="onFileSelected($event, modal)" accept=".pdf,.doc,.docx,.txt">
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
  </div>
</ng-template>